import type { CSSProperties } from "react";
import { Button } from "../components/Button";
import { ScreenShell } from "../components/ScreenShell";
import { useUiText } from "../i18n/useUiText";
import { useAppStore } from "../state/useAppStore";

// One distinct, high-contrast colour per seat so the table can eyeball at a
// glance that nobody picked the same seat.
const SEAT_COLORS = ["#c2410c", "#1d6f6f", "#7c3a86", "#3f6212", "#b4531b"];

export function SeatScreen() {
  const t = useUiText();
  const session = useAppStore((state) => state.session);
  const selectedSeat = useAppStore((state) => state.selectedSeat);
  const goHome = useAppStore((state) => state.goHome);
  const selectSeat = useAppStore((state) => state.selectSeat);
  const confirmSeat = useAppStore((state) => state.confirmSeat);

  if (session === null) {
    return null;
  }

  const seats = Array.from(
    { length: session.playerCount },
    (_, index) => index + 1
  );

  return (
    <ScreenShell
      backLabel={t("common.home")}
      footer={
        <Button disabled={selectedSeat === null} onClick={confirmSeat} wide>
          {t("seat.confirm")}
        </Button>
      }
      onBack={goHome}
    >
      <div className="narrow-column seat-screen">
        <div className="room-code room-code--seat">
          <span>{t("seat.roomLabel")}</span>
          <strong aria-label={session.sessionCode.split("").join(" ")}>
            {session.sessionCode}
          </strong>
        </div>

        <header className="screen-heading screen-heading--centered">
          <h1>{t("seat.title")}</h1>
          <p>{t("seat.body")}</p>
        </header>

        <div
          aria-label={t("seat.title")}
          className={`seat-grid${
            selectedSeat === null ? "" : " seat-grid--has-selection"
          }`}
          role="group"
        >
          {seats.map((seat) => {
            const color = SEAT_COLORS[(seat - 1) % SEAT_COLORS.length]!;
            const isSelected = selectedSeat === seat;
            return (
              <button
                aria-label={`${t("common.seat")} ${seat}`}
                aria-pressed={isSelected}
                className={`seat-button${
                  isSelected ? " seat-button--selected" : ""
                }`}
                key={seat}
                onClick={() => selectSeat(seat)}
                style={{ "--seat-color": color } as CSSProperties}
                type="button"
              >
                <strong>{seat}</strong>
              </button>
            );
          })}
        </div>
      </div>
    </ScreenShell>
  );
}
